module.exports = __webpack_public_path__ + "static/media/main_camera.fbbfb336.svg";